import Moment from '@/_utils/moment';
import NumberStr from '@/_utils/number-str';
import jsonp from 'jsonp';
import Const from '@/_store/const';
import Util from '@/_utils/util';
export default {
    stateStorage : null,
    resetStateStorage(){
        this.stateStorage = null;
    },
    buildImgList(item) {
        let imgs = item.images;
        let resOut = [], tmpImg;
        if (imgs && imgs.length > 0) {
            resOut = imgs.slice(0, 3);
            resOut.forEach(function(item) {
                item = item.replace(`c_fill,w_450,h_300,g_faces`, `c_fill,w_150,h_100,g_faces`);
            });
        }else{
            tmpImg = item.picUrl || item.imageUrl || '';
            resOut = tmpImg ? [tmpImg] : [];
        }
        return resOut;
    },
    generateShowInfo(item) {
        let images = this.buildImgList(item);
        let prePic = images[0] || item.imageUrl || item.picUrl || '';
        let picUrl = prePic.replace('c_fill,w_450,h_300', 'c_fill,w_150,h_100');
        //1.纯文本，2单图，3，三图
        let showType = 2;
        if (images.length === 3) {
            showType = 3;
        } else if (images.length === 0) {
            showType = 1;
        }
        if (item.tip_flag) {
            showType = 0;
        }
        return {
            picUrl,
            images,
            showType
        };
    },
    formatFeedList(_list, _findexFlag = '', _streamType = 0){
        let that = this;
        let list = _list || [];
        let formatItemInfo = {};
        let tmpImgs = [];
        let news_id, read_num, c_flag, pubTime, stat_flag;
        let buildLink = function(o, i, flag){
            let link;
            switch(_streamType) {
                // 录入文章
                case 0:
                    if(o.type === 3){
                        link = (o.articleId && o.authId) ? `/a/${o.articleId}_${o.authId}` : (o.link || '')
                    }else if(o.type === 4){
                        link = o.articleId ? `/picture/${o.articleId}` : (o.link || '')
                    }else {
                        link = o.link || ''
                    }
                    break;
                // mp抓取（mp接口）
                case 2:
                    link = (o.id && o.authorId) ? `/a/${o.id}_${o.authorId}` : (o.url || '')
                    break;
                // 场景化（整合流接口）
                case 3:
                    if(o.type === 1 || o.type == 2) {
                        // 文章
                        link = (o.id && o.authorId) ? `/a/${o.id}_${o.authorId}` : (o.url || '')
                    }else if(o.type === 3) {
                        // 图集
                        link = o.id ? `/picture/${o.id}` : (o.url || '')
                    }else {
                        link = o.url || ''
                    }
                    break;
                default:
                    break;

            }
            link = Util.addQueryArgs(link, {
                _f: flag
            })
            return link;
        }
        list.forEach(function(o, index) {
            stat_flag = `${_findexFlag}_${index + 1}`;
            pubTime = o.createTime || o.publicTime;
            news_id = o.id;
            read_num = that.stateStorage ? that.stateStorage[news_id] || 0 : 0;
            o.read_num = o.read_num || new NumberStr(read_num).format();
            o.title = o.title.replace(/</ig, "&lt;").replace(/>/ig, "&gt;");
            o.fix_c_time = new Moment(Number(pubTime) || new Date().getTime()).fixTime();
            formatItemInfo = that.generateShowInfo(o);
            o.picUrl = formatItemInfo.picUrl;
            o.images = formatItemInfo.images;
            o.showType = formatItemInfo.showType;
            o.pull_time = that.page_no;
            o.stat_flag = stat_flag;
            o.link = buildLink(o, index, stat_flag);
            o.author = o.authorName || o.authName || '搜狐自媒体';
        });
        return list;
    },
    initReadState(news_ids, callback){
        let that = this;
        jsonp('//v2.sohu.com/public-api/articles/pv?articleIds=' + news_ids.join(','), null, function(err, response) {
            let read_dom;
            if (err) {
                console.error(err.message);
            } else {
                if(that.stateStorage && typeof that.stateStorage === 'object'){
                    that.stateStorage = Object.assign(that.stateStorage, response);
                }else{
                    that.stateStorage = response;
                }
                if(typeof callback === 'function') callback();
            }
        });
    },
    pickListByKey(list = [], key = ''){
        let key_list = [];
        list.forEach(function(o) {
            if(o[key]){
                key_list.push(o[key]);
            }   
        });
        return key_list;
    }
}


// WEBPACK FOOTER //
// ./src/components/helper/feed.js